import { ManageCard } from "./ManageCard";
import {
  baseFeeEstimate,
  offeredTransformsType,
  transformsFeeLineItem,
} from "../utils";
import { IAddOnContext, IFlatAddOnDescriptor } from "../types";

/** Legacy flat-fee advanced transforms. The only tier sold self-hosted. */
const transformsAdvanced = {
  productType: "transforms-advanced",
  kind: "flat",
  title: "Transforms",

  isVisible: (ctx: IAddOnContext) =>
    !!ctx.subscribed || offeredTransformsType(ctx) === "transforms-advanced",

  getUpsertAddOns: () => [
    { product_type: "transforms-advanced", prepaid_units: 1 },
  ],

  getEstimateRowItem: (ctx) => ({
    detail: "Advanced: SQL + Python",
    price: baseFeeEstimate(ctx),
  }),

  getBillingRowItem: () => ({ detail: "Advanced: SQL + Python" }),
  getPurchaseLineItem: (ctx) => transformsFeeLineItem(ctx, "Advanced"),

  ManageCard,
} satisfies IFlatAddOnDescriptor;

export default transformsAdvanced;
